<template>
    <label class="switch">
        <input class="switch__input"
            type="checkbox"
            :checked="switched"
            @change="toggleSwitch($event)"
        >
        <span :class="'switch__slider switch__slider--round'" />
    </label>
</template>

<script>
export default {
    name: 'input-switch',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        switched() {
            return this.value ? 'checked' : '';
        },
    },
    methods: {
        toggleSwitch(event) {
            this.$emit('toggleSwitch', {
                index: this.index,
                value: event.target.checked,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.switch {
    position: relative;
    display: inline-block;
    width: 6rem;
    height: 3.4rem;

    &__input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    &__slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: $concrete-color;
        transition: 0.4s;

        &:before {
            position: absolute;
            content: "";
            height: 2.6rem;
            width: 2.6rem;
            left: 0.4rem;
            bottom: 0.4rem;
            background-color: $white-color;
            transition: 0.4s;
        }

        &--round {
            border-radius: 3.4rem;

            &:before {
                border-radius: 50%;
            }
        }
    }

    &__input:checked + &__slider {
        background-color: $lima-color;
    }

    &__input:focus + &__slider {
        box-shadow: 0 0 0.1rem $lima-color;
    }

    &__input:checked + &__slider:before {
        transform: translateX(2.6rem);
    }
}
</style>